import { useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
//
import Header from './header';
import Footer from './footer';


// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 100;

const StyledRoot = styled('div')({
  display: 'flex',
  flexDirection:'column',
  minHeight: '100%',
  overflow: 'hidden',
});

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP,
  },
  backgroundColor:'#fff',
  display: 'flex',
  flexDirection:'column',
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);

  return (
    <>
    <CssBaseline />
    <StyledRoot>
    <Header onOpenNav={() => setOpen(true)} />      
      <Main>
        <Outlet />
      </Main>
      <Footer />
    </StyledRoot>
    </>
  );
}
